import styled from 'styled-components';
import CabIconNoresultsSvg from './car-icon-noresults.svg';

const CabIconNoresults = styled(CabIconNoresultsSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || ''};
  height: ${props => props.height || ''};
  fill: ${props => props.fill || '#647a97'};
  margin: ${props => props.margin || ''};
`;

export default CabIconNoresults;

